import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./login-layout.module.less";

interface IProps {
  headerRender?: () => React.ReactNode | boolean;
  mainFormRender?: () => React.ReactNode | boolean;
}

export default (props: IProps) => {
  const { headerRender, mainFormRender } = props;
  const nav = useNavigate();

  const goToHelpCenter = () => {
    nav("/help-out/center");
  };

  const header = useMemo(() => {
    if (!headerRender) return null;

    if (typeof headerRender !== "function") {
      console.error(`headerRender should be function`);
      return;
    }

    const headerDom = headerRender();
    if (headerDom) {
      return headerDom;
    }

    return null;
  }, [headerRender]);

  const mainForm = useMemo(() => {
    if (!mainFormRender) return null;

    if (typeof mainFormRender !== "function") {
      console.error(`mainFormRender should be function`);
      return;
    }

    const mainFormDom = mainFormRender();
    if (mainFormDom) {
      return mainFormDom;
    }

    return null;
  }, [mainFormRender]);

  return (
    <div className={styles.login}>
      {header}
      <div className={styles.loginMain}>
        {mainForm}

        <div className={styles.footer}>
          <div className={styles.links}>
            <a className={styles.linkItem} onClick={goToHelpCenter}>
              Help Center
            </a>
            <a
              className={styles.linkItem}
              href="https://blog.sayweee.com/"
              target="_blank"
            >
              About Weee!
            </a>
            <a
              className={styles.linkItem}
              href="https://www.sayweee.com/en/account/contact-us"
              target="_blank"
            >
              Contact US
            </a>
          </div>
          <div className={styles.copyright}>
            @copyright 2015-{new Date().getFullYear()} Weee!, Inc.
          </div>
        </div>
      </div>
    </div>
  );
};
